import React, { Suspense } from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import { HubErrorBoundary } from '@atlassian/company-hub-common/ui/hub-error-boundary';
import { SearchDialog } from '@atlassian/search-dialog/search-dialog';

import { SearchSkeletons } from '../../article-search-component/search-dropdown/search-skeletons';
import { HelpObjectSearchError, HelpObjectSearchResults } from './help-object-search-results';

type HelpObjectSearchDropdownProps = {
	cloudId: string;
	helpCenterAri: string;
	inputWidth: number;
	queryWord: string;
};

export const HelpObjectSearchDropdown = ({
	inputWidth,
	queryWord,
	...props
}: HelpObjectSearchDropdownProps): React.JSX.Element => {
	const results = (
		<Suspense fallback={<SearchSkeletons />}>
			<HelpObjectSearchResults {...props} queryWord={queryWord} />
		</Suspense>
	);

	return (
		<SearchDialog
			/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
			style={{
				boxShadow: 'none',
				width: inputWidth,
			}}
			/* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */
		>
			{fg('callout_banner_graceful_handling') ? (
				<HubErrorBoundary
					key={queryWord}
					id="help-object-search-results"
					packageName="article-search"
					operationNames={['helpObjectSearchResultsQuery']}
					fallback={<HelpObjectSearchError />}
				>
					{results}
				</HubErrorBoundary>
			) : (
				results
			)}
		</SearchDialog>
	);
};
